import * as React from "react";
const SvgTick = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 10, fill: "#26A6AE", viewBox: "0 0 12 10", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.0344 0L3.81121 7.8904L0.965605 4.78194L0 5.83674L3.81121 10L12 1.0548L11.0344 0Z" }));
export { SvgTick as ReactComponent };
